import { Theme } from '@/styles/Theme';
import Button from '@/components/common/Button';
import { TbTrash } from 'react-icons/tb';
import { useState } from 'react';
import SelectWorkerActionModal from '@/components/newPayment/WorkerPaymentInfoBox/ManageWorkerPaymentModal/SelectWorkerActionModal';
import UnsubscribeWorkersModal from '@/components/newPayment/WorkerPaymentInfoBox/ManageWorkerPaymentModal/UnsubscribeWorkersModal';
import DeleteWorkerModal from '@/components/newPayment/WorkerPaymentInfoBox/ManageWorkerPaymentModal/DeleteWorkerModal';
import { useSelectedWorkerListStore } from '@/store/selectedWorkerList';
import { toast } from 'react-toastify';
import useDeleteWorkerImmediate from '@/hooks/useDeleteWorkerImmediate';
import useCompanyInfo from '@/hooks/useCompanyInfo';
import usePaymentInfo from '@/hooks/usePaymentInfo';

const UnsubscribeWorkersBtn = () => {
  const { data: companyData } = useCompanyInfo();
  const { data: paymentData } = usePaymentInfo();
  const subscriptionStatus = companyData?.data.subscriptionStatus || 'free';
  const activeWorkerCount = paymentData?.data.activeWorkerCount || 0;
  const [isShowSelectActionModal, setIsShowSelectActionModal] = useState(false);
  const [isShowUnsubscribeModal, setIsShowUnsubscribeModal] = useState(false);
  const [isShowDeleteModal, setIsShowDeleteModal] = useState(false);

  const { selectedUnsubscribeWorkerList, resetSelectedUnsubscribeWorkerList } =
    useSelectedWorkerListStore();

  const { mutate: deleteWorkerImmediate } = useDeleteWorkerImmediate();

  const onUnsubscribeClick = () => {
    if (selectedUnsubscribeWorkerList.length > 0) {
      setIsShowSelectActionModal(true);
    } else {
      toast.error('중단할 작업자를 선택하세요.');
    }
  };

  const handleSelectDisableAutoRenew = () => {
    setIsShowSelectActionModal(false);
    setIsShowUnsubscribeModal(true);
  };

  const handleSelectDeleteWorker = () => {
    setIsShowSelectActionModal(false);
    setIsShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    deleteWorkerImmediate({ workerId: selectedUnsubscribeWorkerList });
    setIsShowDeleteModal(false);
    resetSelectedUnsubscribeWorkerList && resetSelectedUnsubscribeWorkerList();
  };

  return (
    <>
      {isShowSelectActionModal && (
        <SelectWorkerActionModal
          setIsShowModal={setIsShowSelectActionModal}
          selectedWorkers={selectedUnsubscribeWorkerList}
          onSelectDisableAutoRenew={handleSelectDisableAutoRenew}
          onSelectDeleteWorker={handleSelectDeleteWorker}
          subscriptionStatus={subscriptionStatus}
          activeWorkerCount={activeWorkerCount}
        />
      )}
      {isShowUnsubscribeModal && (
        <UnsubscribeWorkersModal
          setIsShowModal={setIsShowUnsubscribeModal}
          selectedWorkers={selectedUnsubscribeWorkerList}
          resetSelectedUnsubscribeWorkerList={resetSelectedUnsubscribeWorkerList}
        />
      )}
      {isShowDeleteModal && (
        <DeleteWorkerModal
          setIsShowModal={setIsShowDeleteModal}
          selectedWorkers={selectedUnsubscribeWorkerList}
          onConfirmDelete={handleConfirmDelete}
        />
      )}
      <Button
        height='2.125rem'
        onClick={onUnsubscribeClick}
        border={`0.0625rem solid ${Theme.colors.G_3}`}
        color={Theme.colors.BLACK}
        backgroundColor={Theme.colors.WHITE}
      >
        <TbTrash size='1.25rem' />
        선택 중단 신청
      </Button>
    </>
  );
};

export default UnsubscribeWorkersBtn;
